import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AccountService } from '../../../../../../../services/account/account.service';
import { DocumentTemplateService } from '../../../../../../../services/document-template/document-template.service';
import { DocumentPolicy } from '../../../../../../../models/document-template';

@Component({
  selector: 'app-document-policy-edit',
  templateUrl: './document-policy-edit.component.html',
  styleUrls: ['./document-policy-edit.component.css']
})
export class DocumentPolicyEditComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private documentTemplateService: DocumentTemplateService
  ) {}

  public documentPolicy: DocumentPolicy;

  public documentPolicyErrorMessage = '';
  public documentPolicyErrors: any = {};

  public loadingPolicy = false;

  public documentPolicyNotFound = false;
  public serverError: number = null;

  ngOnInit() {
    const routeParams = this.route.snapshot.params;

    this.loadDocumentPolicy(routeParams.id);
  }

  public loadDocumentPolicy(policyId: string) {
    this.loadingPolicy = true;

    const policyIdInt = parseInt(policyId, 10);
    if (isNaN(policyIdInt)) {
      this.documentPolicyNotFound = true;
      this.loadingPolicy = false;
      return;
    }

    this.documentTemplateService
      .getDocumentPolicy(policyIdInt)
      .then(policy => {
        this.documentPolicy = policy;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else if (reason.status === 404) {
          this.documentPolicyNotFound = true;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingPolicy = false; });
  }

  public handleSave() {
    this.loadingPolicy = true;

    this.documentPolicyErrorMessage = '';

    this.documentTemplateService
      .updateDocumentPolicy(this.documentPolicy)
      .then(updatedDocumentPolicy => {
        this.documentPolicy = updatedDocumentPolicy;

        this.router.navigate(
          ['/document-policies'],
          {
            state: {
              feedback: {
                text: 'Policy \'' + this.documentPolicy.name + '\' saved successfully.',
                status: 'success'
              }
            }
          }
        );
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.documentPolicyErrors = reason.error;
          this.documentPolicyErrorMessage = 'Please correct the provided errors and try again.';
        } else if (reason.status === 403) {
          this.documentPolicyErrorMessage = 'You do not have permission to edit document policies.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingPolicy = false; });
  }

}
